import './main.scss';
import Carousel from "../src/scripts/components/carousel";
import Navigation from "../src/scripts/components/navigation";
import ResourcesFilters from './scripts/components/resources-filters';
import ResourcesPreviousAndNext from "../src/scripts/components/resources-previous-and-next";
import ResourcesSort from "../src/scripts/components/resources-sort";
import Video from "../src/scripts/components/video";
import DeleteMemberForm from './scripts/components/delete-member';
import Accordion from './scripts/components/accordion';
import { ValidationService } from 'aspnet-client-validation';
window.addEventListener("load", (event) => {
    //console.log('Hello world');
    Navigation.init();
    ResourcesFilters.init();
    ResourcesPreviousAndNext.init();
    ResourcesSort.init();
    Video.init();
    Carousel.init();
    DeleteMemberForm.init();
    Accordion.init();
    const formElement = document.querySelector('[data-component="LoginRegisterForm"]');
    if (formElement) {
        let v = new ValidationService();
        v.bootstrap();
    }
});
